import React, { useEffect } from 'react';

const useDfpSlot = ( {path, size, id, className} ) => {
	return null;
	/*
	const screenWidth = window.innerWidth;
	let i = 0;
	while (size[i][0] > screenWidth && i < size.length - 1)
		i++;

	const width = size[i][0];
	const height = size[i][1];

	useEffect(() => {
		let slot = null;
		let timeout = null;
		if (!process.env.REACT_APP_USE_DFP) {
			return;
		}
		const execGPT = () => {
			timeout = setTimeout(() => {
				let control = document.getElementById(id);
				if (!control) {
					console.log("Wait ", id);
					execGPT();
					return;
				}
				console.log("Create ", id, document.getElementById(id));
				const googletag = window.googletag || {};
				googletag.cmd = googletag.cmd || [];
				googletag.cmd.push(function() {
					console.log(path, [ width, height ], id);
					slot = googletag.defineSlot(path, [[ width, height ]], id);
					if (slot)
						slot.addService(googletag.pubads());
					else 
						console.log(id, "failed!", document.getElementById(id));

					googletag.pubads().enableSingleRequest();
					googletag.enableServices();
				});
				googletag.cmd.push(function() {
					googletag.display(id);
				});
			}, 250);
		};
		execGPT();

		return function() {
			console.log("Destroy ", id);
			window.googletag.cmd.push(() => {
				clearTimeout(timeout);
				if (slot) {
					window.googletag.destroySlots([ slot ]);
				}
			});
		};
	}, [path, width, height, id]);

	if (!process.env.REACT_APP_USE_DFP) {
		return null;
	}

	return (
		<div
			key={id}
			id={id}
			style={{ width: width + 'px' }}
			className={"gpt " + className}
		/>
	);
	*/
};

export default useDfpSlot;

